var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0465 72H25.9535C7.7693 72 0 64.2307 0 46.0465V25.9535C0 7.7693 7.7693 0 25.9535 0H46.0465C64.2307 0 72 7.7693 72 25.9535V46.0465C72 64.2307 64.2307 72 46.0465 72ZM25.9535 5.02326C10.5153 5.02326 5.02326 10.5153 5.02326 25.9535V46.0465C5.02326 61.4846 10.5153 66.9767 25.9535 66.9767H46.0465C61.4846 66.9767 66.9767 61.4846 66.9767 46.0465V25.9535C66.9767 10.5153 61.4846 5.02326 46.0465 5.02326H25.9535Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2444 47.9891C30.5746 47.9891 29.9383 47.7212 29.4695 47.2524L19.9923 37.7752C19.0211 36.804 19.0211 35.1966 19.9923 34.2254C20.9635 33.2542 22.5709 33.2542 23.5421 34.2254L31.2444 41.9277L48.4574 24.7147C49.4286 23.7435 51.036 23.7435 52.0072 24.7147C52.9783 25.6859 52.9783 27.2933 52.0072 28.2645L33.0193 47.2524C32.5504 47.7212 31.9141 47.9891 31.2444 47.9891Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.88ed759fca099784eb12566699ae93e8.svg";
export { ForwardRef as ReactComponent };